import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router-dom";

import TeamHistory from "components/TeamHistory";

import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import config from "config.json";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { uploadFileToDocument, createDocument } from "services/file_service";

import { getDocumentById } from "services/documents_service";
import unknownUser from "img/unknown_user.png";

import { changePassLoggedIn, updateLocalStorageAccInfo } from "services/auth_service";
import { getAccount, putAccount } from "services/account_service";
import {
  createTeamHistory,
  putTeamHistory,
} from "services/teamhistory_service";

import { logout as logoutService } from "services/auth_service";
import moment from "moment";

function Account() {
  const { t } = useTranslation();
  const [currentPassword, setCurrentPassword] = useState("");
  const [accountRole, setAccountRole] = useState({});
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [accountHistory, setAccountHistory] = useState([]);
  const [birthdate, setBirthdate] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [img, setImg] = useState(unknownUser);
  const [imglogo, setImglogo] = useState(unknownUser);
  const navigate = useNavigate();

  const { register, handleSubmit, setValue, control } = useForm({});

  const changeHandler = async (event) => {
    let uuid = uuidv4();
    const doc = await createDocument(
      null,
      uuid + event.target.files[0].name,
      null
    );

    await uploadFileToDocument(doc.id, event.target.files[0]);

    await putAccount(localStorage.getItem("accountId"), { logo: doc.id });
    window.location.reload();
  };

  const changeEquipmentLogoHandler = async (event) => {
    let uuid = uuidv4();
    const doc = await createDocument(
      null,
      uuid + event.target.files[0].name,
      null
    );

    await uploadFileToDocument(doc.id, event.target.files[0]);

    await putAccount(localStorage.getItem("accountId"), {
      equipment_logo: doc.id,
    });
    window.location.reload();
  };

  useEffect(() => {
    async function getAcc() {
      const accInfo = await getAccount(localStorage.getItem("accountId"));
      setAccountRole(accInfo.attributes.role);

      if (accInfo.attributes?.date_of_birth) {
        let dateofbirth = moment(
          accInfo.attributes.date_of_birth,
          "YYYY-MM-DD"
        );
        setBirthdate(dateofbirth.toDate());
      }

      setValue("email", accInfo.attributes.users.data[0].attributes.username);
      setHistory(accInfo.attributes.team_histories.data);
      setAccountHistory(
        accInfo.attributes.team_histories.data.map((el) => {
          return { id: el.id, ...el.attributes };
        })
      );

      setValue("preferred_foot", accInfo.attributes.preferred_foot);
      setValue("name", accInfo.attributes.name);
      setValue("role", accInfo.attributes.role);
      setValue("age", accInfo.attributes.age);
      setValue("height", accInfo.attributes.height);
      setValue("weight", accInfo.attributes.weight);
      setValue("nationality", accInfo.attributes.nationality);
      setValue("naturality", accInfo.attributes.naturality);
      setValue("phone_number", accInfo.attributes.phone_number);
      setValue("date_of_birth", accInfo.attributes.date_of_birth);
      setValue("locality", accInfo.attributes.locality);
      setValue("site", accInfo.attributes.site);
      setValue("president_name", accInfo.attributes.president_name);
      setValue("stadium", accInfo.attributes.stadium);
      setValue("naturality", accInfo.attributes.naturality);
      setValue("foundation_year", accInfo.attributes.foundation_year);
      setValue("facebook_link", accInfo.attributes.facebook_link);
      setValue("instagram_link", accInfo.attributes.instagram_link);

      if (accInfo.attributes?.logo?.data?.id) {
        let docs = await getDocumentById(accInfo.attributes?.logo?.data?.id);

        if (docs.attributes?.body?.data?.attributes?.url) {
          setImg(docs.attributes?.body?.data?.attributes?.url);
        }
      }

      if (accInfo.attributes?.equipment_logo?.data?.id) {
        let docLogo = await getDocumentById(
          accInfo.attributes?.equipment_logo?.data?.id
        );

        if (docLogo.attributes?.body?.data?.attributes?.url) {
          setImglogo(docLogo.attributes?.body?.data?.attributes?.url);
        }
      }
    }

    getAcc();
  }, []);

  const canSubmitChangePass = () => {
    if (password.length > 7 && password === passwordConfirmation) {
      return true;
    }

    return false;
  };

  const setHistory = (history) => {
    setAccountHistory(history);
  };

  const submitForm = async (data) => {
    try {
      if (birthdate) {
        let datestrapi = moment(birthdate).format("YYYY-MM-DD"); // Strapi date format;
        data = { ...data, date_of_birth: datestrapi };
      }

      await putAccount(localStorage.getItem("accountId"), data);
      await updateLocalStorageAccInfo();

      for (let history of accountHistory) {
        if (history.id) {
          await putTeamHistory(history.id, history);
        } else {
          await createTeamHistory({
            account: localStorage.getItem("accountId"),
            ...history,
          });
        }
      }

      navigate("/inicio"); 
    } catch (exception) {
      console.log(
        "🚀 ~ file: Account.js:64 ~ submitForm ~ exception:",
        exception
      );
    }
  };

  const changePassSubmit = async () => {
    setErrorMsg("");

    if (password !== "" && password !== passwordConfirmation) {
      setErrorMsg(t("ERROR_pass_does_not_match"));
      return;
    }

    if (password.length < config.MIN_PASSWORD_CHAR) {
      setErrorMsg("ERROR_pass_min_length", { chars: config.MIN_PASSWORD_CHAR });
      return;
    }

    try {
      await changePassLoggedIn(password, passwordConfirmation, currentPassword);
      logoutService();
      window.location.reload();
    } catch (exception) {
      setErrorMsg(t("ERROR_unexpected"));
    }
  };

  return (
    <div className="App">
      <section className="section">
        <div className="columns credencial-style">
          <div className="column is-7 exist">
            <label className="label">
              {accountRole === "Clube" ? "Logo do clube" : "Imagem de perfil"}
            </label>
            <br></br>
            <br></br>
            <br></br>

            <button
              style={{ border: "0px", padding: "0" }}
              className="button is-abilioo"
            >
              <input
                className="file-input"
                type="file"
                style={{
                  width: "200px",
                  height: "175px",
                }}
                name="resume"
                onChange={(event) => changeHandler(event)}
              />
              <img
                style={{ width: "200px", height: "175px" }}
                alt="personImage"
                src={`${img}`}
              ></img>
            </button>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            {accountRole === "Clube" && (
              <>
                <button
                  style={{ border: "0px", padding: "0" }}
                  className="button is-abilioo"
                >
                  <input
                    className="file-input"
                    type="file"
                    style={{
                      width: "200px",
                      height: "175px",
                    }}
                    name="resume"
                    onChange={(event) => changeEquipmentLogoHandler(event)}
                  />
                  <img
                    style={{ width: "200px", height: "175px" }}
                    alt="personImage"
                    src={`${imglogo}`}
                  ></img>
                </button>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
              </>
            )}
            <form onSubmit={handleSubmit((data) => submitForm(data))}>
              <div className="block">
                <div className="field">
                  <label className="label">Nome</label>
                  <p className="control">
                    <input
                      className="input"
                      type="text"
                      disabled={accountRole === "Clube" ? true : false}
                      {...register("name", {
                        required: true,
                        minLength: 5,
                      })}
                    />
                  </p>
                </div>
              </div>

              <div className="block">
                <div className="field">
                  <label className="label">Email</label>
                  <p className="control">
                    <input
                      className="input"
                      type="text"
                      disabled={true}
                      {...register("email", {
                        required: true,
                        minLength: 5,
                      })}
                    />
                  </p>
                </div>
              </div>

              <div className="block">
                <div className="field">
                  <label className="label">Número de telemóvel</label>
                  <p className="control">
                    <input
                      className="input"
                      type="text"
                      {...register("phone_number", {
                        minLength: 5,
                      })}
                    />
                  </p>
                </div>
              </div>

              <div className="block">
                <div className="field">
                  <label className="label">Perfil</label>
                  <p className="control">
                    <input
                      className="input"
                      type="text"
                      disabled={true}
                      {...register("role", {
                        required: true,
                        minLength: 5,
                      })}
                    />
                  </p>
                </div>
              </div>
              {accountRole !== "Clube" && (
                <>
                  <div className="block">
                    <div className="field">
                      <label className="label">Data de nascimento</label>
                      <p className="control">
                        <DatePicker
                          scrollableYearDropdown
                          yearDropdownItemNumber={30}
                          className="input"
                          selected={birthdate}
                          value={birthdate}
                          onChange={(value) => setBirthdate(value)}
                          dateFormat="dd/MM/yyyy"
                          showYearDropdown
                          dropdownMode="select"
                        />
                      </p>
                    </div>
                  </div>
                  <div className="block">
                    <div className="field">
                      <label className="label">Nacionalidade</label>
                      <p className="control">
                        <input
                          className="input"
                          type="text"
                          {...register("nationality", {})}
                        />
                      </p>
                    </div>
                    <div className="block">
                      <div className="field">
                        <label className="label">Naturalidade</label>
                        <p className="control">
                          <input
                            className="input"
                            type="text"
                            {...register("naturality", {})}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {accountRole === "Clube" && (
                <>
                  <div className="block">
                    <div className="field">
                      <label className="label">Localidade</label>
                      <p className="control">
                        <input
                          className="input"
                          placeholder="Lisboa"
                          type="text"
                          {...register("locality", {})}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="block">
                    <div className="field">
                      <label className="label">Nome do estádio</label>
                      <p className="control">
                        <input
                          className="input"
                          type="text"
                          {...register("stadium", {})}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="block">
                    <div className="field">
                      <label className="label">Site</label>
                      <p className="control">
                        <input
                          className="input"
                          placeholder="www.website.com"
                          type="text"
                          {...register("site", {})}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="block">
                    <div className="field">
                      <label className="label">Nome Presidente</label>
                      <p className="control">
                        <input
                          className="input"
                          type="text"
                          {...register("president_name", {})}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="block">
                    <div className="field">
                      <label className="label">Ano de fundação</label>
                      <p className="control">
                        <input
                          className="input"
                          type="number"
                          min="1850"
                          max="2050"
                          placeholder="1985"
                          {...register("foundation_year", {})}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="block">
                    <div className="field">
                      <label className="label">Utilizador Facebook</label>
                      <p className="control">
                        <input
                          className="input"
                          type="text"
                          placeholder="www.instragram.com/xxx"
                          {...register("facebook_link", {})}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="block">
                    <div className="field">
                      <label className="label">Utilizador Instagram</label>
                      <p className="control">
                        <input
                          className="input"
                          type="text"
                          placeholder="www.facebook.com/xxx"
                          {...register("instagram_link", {})}
                        />
                      </p>
                    </div>
                  </div>
                </>
              )}

              {accountRole === "Jogador" && (
                <>
                  <div className="block">
                    <div className="field">
                      <label className="label">Altura (cm)</label>
                      <p className="control">
                        <input
                          className="input"
                          type="float"
                          {...register("height", {})}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="block">
                    <div className="field">
                      <label className="label">Peso (kg)</label>
                      <p className="control">
                        <input
                          className="input"
                          type="number"
                          {...register("weight", {})}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="block">
                    <div className="field">
                      <label className="label">Pé preferêncial</label>
                      <Controller
                        name="preferred_foot"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            options={config.PREFERRED_FOOT}
                            onChange={(val) => {
                              onChange(val.value);
                              setRefresh(!refresh); // must set to have a refresh when setting this up
                            }}
                            value={config.PREFERRED_FOOT.find((c) => {
                              return c.value === value;
                            })}
                          />
                        )}
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label className="label">Histórico de equipas</label>
                    <TeamHistory
                      setHistory={setHistory}
                      history={accountHistory}
                    ></TeamHistory>
                  </div>
                </>
              )}

              {accountRole === "Treinador" && (
                <div className="field">
                  <label className="label">Histórico de equipas</label>
                  <TeamHistory
                    type={"Treinador"}
                    setHistory={setHistory}
                    history={accountHistory}
                  ></TeamHistory>
                </div>
              )}

              <button className="button">Guardar</button>
            </form>
          </div>

          {/*
              CHANGE PASSWORD CODE
            */}
          <div className="column is-4  exist">
            <h2 className="title is-4">{t("change_pass")}</h2>
            <div className="field">
              <label className="label">{t("current_pass")}</label>
              <div className="control">
                <input
                  className="input"
                  type="password"
                  value={currentPassword}
                  onChange={(evt) => setCurrentPassword(evt.target.value)}
                  placeholder={t("confirm_password")}
                />
              </div>
            </div>
            <div className="field">
              <label className="label">{t("new_pass")}</label>
              <div className="control">
                <input
                  className="input"
                  type="password"
                  value={password}
                  onChange={(evt) => setPassword(evt.target.value)}
                  placeholder={t("pass")}
                />
              </div>
            </div>
            <div className="field">
              <label className="label">{t("repeat_password")}</label>
              <div className="control">
                <input
                  className="input"
                  type="password"
                  value={passwordConfirmation}
                  onChange={(evt) => setPasswordConfirmation(evt.target.value)}
                  placeholder={t("confirm_password")}
                />
              </div>
            </div>
            <div className="block">
              <button
                className="button btn1"
                onClick={changePassSubmit}
                disabled={!canSubmitChangePass}
              >
                Alterar
              </button>
            </div>
            {errorMsg !== "" && (
              <div>
                <br />
                <article className="message is-warning">
                  <div className="message-body">{errorMsg}</div>
                </article>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
export default Account;
